import { html, property } from 'lit-element';
import { nothing } from 'lit-html';
import { KatLitElement, register } from '../../shared/base';
import baseStyles from '../../shared/base/base.lit.scss';
import styles from './kpi-bar.lit.scss';

/**
 * @component {kat-kpi-bar} KatKpiBar The KPI Bar allows for the display of a few key data points along with a limited visualization for each point. This module makes it easier to summarize and provide insight into the status of the page.
 * @status Production
 * @theme flo
 * @slot default Should be filled with `kpi-bar-item` elements.
 * @slot kpi-bar-utility-actions Utility section for KPI filters actions
 * @subcomponent ./kpi-bar-item.ts
 * @example Default {"header": "Sample KPI Bar", "subheader": "Last updated: Today at 11:07AM", "content": "<div slot=\"kpi-bar-utility-actions\"><kat-dropdown value=\"us\"><kat-option value=\"ca\">Canada</kat-option><kat-option value=\"mx\">Mexico</kat-option><kat-option value=\"us\">United States</kat-option></kat-dropdown></div><kat-kpi-bar-item label=\"FBA sales\" metric=\"$1,234.00\" trend=\"increase\" trend-polarity=\"positive\" secondary-label=\"Additional details\" show-control-icon=\"true\"><div>Bar Chart</div></kat-kpi-bar-item><kat-kpi-bar-item label=\"Units ordered-1\" metric=\"782\" trend=\"decrease\"><div>Line Chart</div></kat-kpi-bar-item><kat-kpi-bar-item label=\"Units inbound-1\" metric=\"1,416\" trend=\"increase\" trend-polarity=\"negative\" secondary-label=\"+10% Weekly\"><div>Bar Chart</div></kat-kpi-bar-item><kat-kpi-bar-item label=\"Unfulfillable inventory-1\" metric=\"-\" trend-polarity=\"neutral\" show-control-icon=\"true\"><div>Data missing or unavailable for date range.</div></kat-kpi-bar-item><kat-kpi-bar-item label=\"Unfulfillable inventory-2\" metric=\"-\"><div>Pie Chart</div></kat-kpi-bar-item><kat-kpi-bar-item label=\"Units ordered-2\" metric=\"782\" trend=\"increase\" secondary-label=\"+20% Weekly\" show-control-icon=\"true\"><div>Line Chart</div></kat-kpi-bar-item><kat-kpi-bar-item label=\"Units inbound-2\" metric=\"1,416\" trend=\"neutral\" secondary-label=\"Total NA Sales\" show-control-icon=\"true\"><div>Bar Chart</div></kat-kpi-bar-item>"}
 */
@register('kat-kpi-bar')
export class KatKpiBar extends KatLitElement {
  static get styles() {
    return [baseStyles, styles];
  }

  /** Header for KPI bar. */
  @property()
  header: string;

  /** Sub header for KPI bar. */
  @property()
  subheader?: string;

  renderSubHeader() {
    return html`
      ${!this.subheader
        ? nothing
        : html`<div class="sub-header">${this.subheader}</div>`}
    `;
  }

  render() {
    return html`
      <div class="header">
        <h2>${this.header}</h2>
      </div>
      ${this.renderSubHeader()}
      <div class="utility-actions">
        <slot name="kpi-bar-utility-actions"></slot>
      </div>
      <div class="bar-items">
        <slot></slot>
      </div>
    `;
  }
}
